import { RightOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import { useHistory } from 'react-router';

interface Props {
  id: number;
  name: string;
  role: string;
  updatedAt: any;
}

const EditMember = ({id, name, role, updatedAt }: Props) => {
  const history = useHistory();

  const viewMore = (id: number, role: string) => {
    if (role === '셀러') {
      // seller detail
      history.push(`busk/sellers/${id}`)
    } else if (role === '물류센터') {
      //warehouse detail
      history.push(`busk/logistic/${id}`)
    }
  };

  return (
    <>
      <div style={{ padding: '2rem' }}>
        <Typography.Title level={5}>{name}</Typography.Title>
        <Row>
          <Col flex={1}>
            <Typography.Text>{updatedAt}</Typography.Text>
          </Col>

          <Col flex={0} onClick={() => viewMore(id, role)} className="view-more">
            <Typography.Text>{role}</Typography.Text>
            <RightOutlined style={{ marginLeft: '1rem' }} />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default EditMember;
